import { render, staticRenderFns } from "./InputFieldsDemo.vue?vue&type=template&id=6cc44d56&scoped=true&"
import script from "./InputFieldsDemo.vue?vue&type=script&lang=js&"
export * from "./InputFieldsDemo.vue?vue&type=script&lang=js&"
import style0 from "./InputFieldsDemo.vue?vue&type=style&index=0&id=6cc44d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc44d56",
  null
  
)

export default component.exports